// Radha — staff-side reads of customer portal messages (054). Replies write
// directly (RLS-scoped to the caller's tenant); a customer's own INSERT only
// ever happens through the public portal-message Edge Function, never here.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { supabase } from "../lib/supabase";

export interface PortalMessage {
  id: string; invoice_id: string | null; customer_name: string;
  kind: "dispute" | "question" | "payment_proof";
  body: string; payment_reference: string | null; status: "open" | "resolved";
  staff_reply: string | null; replied_at: string | null; created_at: string;
}

export function usePortalMessages() {
  return useQuery({
    queryKey: ["portal-messages"],
    queryFn: async (): Promise<PortalMessage[]> => {
      const { data, error } = await supabase
        .from("portal_messages")
        .select("id, invoice_id, customer_name, kind, body, payment_reference, status, staff_reply, replied_at, created_at")
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 15_000,
  });
}

export function useReplyToPortalMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, reply, resolve }: { id: string; reply: string; resolve: boolean }) => {
      const { error } = await supabase
        .from("portal_messages")
        .update({ staff_reply: reply, status: resolve ? "resolved" : "open" })
        .eq("id", id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["portal-messages"] }),
  });
}
